import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${colors.background};
`;

export const HeaderCard = styled.div`
    padding: 20px 20px 0;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const HeaderActions = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
`;

export const BackButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    border: 0;
    background: transparent;
    padding: 0;
    color: ${colors.brandPrimary};
    cursor: pointer;
    font: inherit;
    margin-bottom: 12px;

    &:hover {
        color: ${colors.brandDark};
    }
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-top: 16px;
`;

export const Title = styled.h2`
    margin: 0;
    color: ${colors.textPrimary};
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
`;

export const SummaryGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
    margin-top: 20px;
    margin-bottom: 18px;
`;

export const SummaryCard = styled.button`
    display: flex;
    justify-content: space-between;
    gap: 24px;
    width: 100%;
    border: 1px solid ${colors.border};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
    background: ${colors.white};
    padding: 16px;
    text-align: left;
    cursor: pointer;
    transition: background 0.15s ease-in-out;

    &:disabled {
        cursor: default;
        opacity: 0.75;
    }

    &:hover {
        background: ${colors.brandLight};
    }
`;

export const SummaryGroup = styled.div`
    min-width: 0;
`;

export const SummaryLabel = styled.div`
    margin-bottom: 6px;
    color: ${colors.textSecondary};
    font-size: 13px;
    line-height: 18px;
`;

export const SummaryValue = styled.div`
    color: ${colors.textPrimary};
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    overflow-wrap: anywhere;
`;

export const SummaryDownloadWrapper = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const SectionGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
`;

export const SectionCard = styled.section`
    padding: 20px;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const SectionTitle = styled.h3`
    margin: 0 0 20px;
    color: ${colors.textPrimary};
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
`;

export const InfoList = styled.dl`
    display: grid;
    grid-template-columns: minmax(160px, 1fr) minmax(120px, 1fr);
    column-gap: 24px;
    row-gap: 16px;
    margin: 0;
`;

export const InfoLabel = styled.dt`
    color: ${colors.textSecondary};
    font-size: 13px;
    line-height: 18px;
`;

export const InfoValue = styled.dd`
    margin: 0;
    color: ${colors.textPrimary};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    overflow-wrap: anywhere;
`;
